import { Link, useNavigate } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { DocumentCard } from "@/components/ir/DocumentCard";
import { DOCUMENTS } from "@/lib/documents";

export function DocumentListPage() {
  const navigate = useNavigate();

  return (
    <>
      <PageMeta
        title="Documents | COSX Dataroom"
        description="Confidential investor documents including pitch deck, financial model, and legal materials. Access requires a signed NDA."
        path="/ir/dataroom/docs"
        noindex
      />

      <div className="relative z-10 pt-[var(--topnav-height)] px-8">
        <div className="max-w-6xl mx-auto w-full pt-16">
          <Link
            to="/ir/dataroom"
            className="inline-flex items-center gap-2 text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] hover:text-[var(--color-fg)] transition-colors mb-10"
          >
            ← Back to dataroom
          </Link>
        </div>
      </div>

      <ScrollSection id="documents" title="Dataroom" subtitle="All documents below are confidential and subject to your signed NDA." compact>
        {/* Desktop table */}
        <div className="hidden md:block overflow-x-auto border border-[var(--color-border)]">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-[var(--color-border)]">
                {["ID", "Title", "Category", "Date", "Version"].map((h) => (
                  <th
                    key={h}
                    className="px-5 py-3.5 text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)] font-medium"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {DOCUMENTS.map((doc) => (
                <tr
                  key={doc.id}
                  className="border-b border-[var(--color-border)] last:border-b-0 hover:bg-[var(--color-bg-secondary)] transition-colors cursor-pointer"
                  onClick={() => navigate(`/ir/dataroom/docs/${doc.id}`)}
                >
                  <td className="px-5 py-3.5 text-xs font-[family-name:var(--font-mono)] text-[var(--color-accent)]">
                    {doc.id}
                  </td>
                  <td className="px-5 py-3.5 text-sm font-medium text-[var(--color-fg)]">
                    {doc.title}
                  </td>
                  <td className="px-5 py-3.5 text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)]">
                    {doc.category}
                  </td>
                  <td className="px-5 py-3.5 text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)]">
                    {doc.date}
                  </td>
                  <td className="px-5 py-3.5 text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)]">
                    {doc.version}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="flex flex-col gap-4 md:hidden">
          {DOCUMENTS.map((doc) => (
            <DocumentCard key={doc.id} doc={doc} />
          ))}
        </div>
      </ScrollSection>
    </>
  );
}
